/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Media_Not_Found_ToastInputs */

const en_load_project_file_media_not_found_toast = /** @type {(inputs: Load_Project_File_Media_Not_Found_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media file not found. Please re-import media.`)
};

const fr_load_project_file_media_not_found_toast = /** @type {(inputs: Load_Project_File_Media_Not_Found_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fichier media introuvable. Veuillez reimporter le media.`)
};

const de_load_project_file_media_not_found_toast = /** @type {(inputs: Load_Project_File_Media_Not_Found_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mediendatei nicht gefunden. Bitte importieren Sie die Mediendatei erneut.`)
};

const it_load_project_file_media_not_found_toast = /** @type {(inputs: Load_Project_File_Media_Not_Found_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File multimediale non trovato. Reimporta il file multimediale.`)
};

const ru_load_project_file_media_not_found_toast = /** @type {(inputs: Load_Project_File_Media_Not_Found_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Медиафайл не найден. Пожалуйста, импортируйте медиафайл повторно.`)
};

const es_load_project_file_media_not_found_toast = /** @type {(inputs: Load_Project_File_Media_Not_Found_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontró el archivo multimedia. Vuelva a importarlo.`)
};

const zh_cn2_load_project_file_media_not_found_toast = /** @type {(inputs: Load_Project_File_Media_Not_Found_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到媒体文件。请重新导入媒体文件。`)
};

const ja_load_project_file_media_not_found_toast = /** @type {(inputs: Load_Project_File_Media_Not_Found_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアファイルが見つかりません。メディアを再インポートしてください。`)
};

const hi_load_project_file_media_not_found_toast = /** @type {(inputs: Load_Project_File_Media_Not_Found_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया फ़ाइल नहीं मिली। कृपया मीडिया को पुनः आयात करें।`)
};

const pt_pt2_load_project_file_media_not_found_toast = /** @type {(inputs: Load_Project_File_Media_Not_Found_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivo de mídia não encontrado. Por favor, importe a mídia novamente.`)
};

/**
* | output |
* | --- |
* | "Media file not found. Please re-import media." |
*
* @param {Load_Project_File_Media_Not_Found_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_media_not_found_toast = /** @type {((inputs?: Load_Project_File_Media_Not_Found_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Media_Not_Found_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_load_project_file_media_not_found_toast(inputs)
	if (locale === "de") return de_load_project_file_media_not_found_toast(inputs)
	if (locale === "it") return it_load_project_file_media_not_found_toast(inputs)
	if (locale === "ru") return ru_load_project_file_media_not_found_toast(inputs)
	if (locale === "es") return es_load_project_file_media_not_found_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_load_project_file_media_not_found_toast(inputs)
	if (locale === "ja") return ja_load_project_file_media_not_found_toast(inputs)
	if (locale === "hi") return hi_load_project_file_media_not_found_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_load_project_file_media_not_found_toast(inputs)
	return en_load_project_file_media_not_found_toast(inputs)
});